import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="text-center max-w-md">
          <p className="font-label text-6xl md:text-7xl font-extrabold text-primary-500">404</p>
          <h1 className="mt-4 text-xl md:text-2xl font-extrabold text-foreground-950">
            这个页面走丢了
          </h1>
          <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
            你访问的地址不存在，或者内容已经下线。回到首页继续挑一部短片看看吧。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/category/shortfilms"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览短片
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}